module.exports = __webpack_public_path__ + "img/daily gong logo.ddac267c.png";